import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SignatureCanvas from "react-signature-canvas";
import './adminDashboard.css';
import './dashboardmain.css';
import "./horizonTable.css";
import "../forms/themeCheckbox.css";
import {
  adminEditLabelStyle,
  adminEditInputStyle,
  parseSiteRegisterDate,
  formatSiteRegisterDate,
  siteRegisterDatePickerProps,
  adminEditModalOverlayStyle,
  adminEditModalContentStyle,
  adminEditModalHeaderStyle,
  adminEditModalTitleStyle,
  adminEditModalBodyStyle,
  adminEditModalFooterStyle,
  adminEditCancelBtnStyle,
  adminEditSaveBtnStyle,
  adminEditSigBoxStyle,
} from "./adminEditModalTheme";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import onsiteproLogo from '../../assets/logo2 2.png';
import AdminTaylorImportModal, { adminIsPrimaryAdmin } from "./AdminTaylorImportModal";
import { ensureFormUuid, noopCreateSuccess } from "../../utils/formUuid";
import { buildSharePointFileName, toDdMmYyyy, addedByName } from "../../utils/formPdfHelpers";

import { canEditDeleteRecords } from "../../utils/rolePermissions";
// function UkpnPPMPage() { // Duplicate, remove this line
function UkpnPPMPage() {
  const canEditDelete = canEditDeleteRecords();
  // State
  const [ppms, setPpms] = useState([]);
  const [appUsers, setAppUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [uploadingKey, setUploadingKey] = useState(null);
  const generatingPdfRef = useRef(false);
  const [showSharePointUploadModal, setShowSharePointUploadModal] = useState(false);
  const [sharePointUploadRecord, setSharePointUploadRecord] = useState(null);
  const [sharePointPhaseType, setSharePointPhaseType] = useState('phase');
  const [sharePointPhaseNumber, setSharePointPhaseNumber] = useState('15');
  const [sharePointNetwork, setSharePointNetwork] = useState('');

  // Modal state
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const isAdminUser = adminIsPrimaryAdmin();
  const [deleteId, setDeleteId] = useState(null);

  // Form state
  const [newPPM, setNewPPM] = useState({
    formUuid: '',
    userId: '',
    customerName: '',
    jobNumber: '',
    site: '',
    date: '',
    engineerName: '',
    timeOn: '',
    timeOff: '',
    comments: '',
    materials: '',
    clientSignature: '',
    engineerSignature: ''
  });
  const [editPPM, setEditPPM] = useState(null);
  const [editClientSignature, setEditClientSignature] = useState("");
  const [editEngineerSignature, setEditEngineerSignature] = useState("");
  const clientSigCanvasRef = useRef(null);
  const engineerSigCanvasRef = useRef(null);
  const editClientSigCanvasRef = useRef(null);
  const editEngineerSigCanvasRef = useRef(null);

  // Fetch all UKPN PPMs
  const fetchPPMs = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const res = await fetch(baseUrl + "/api/ukpn-ppm", {
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok && data.success && Array.isArray(data.data)) {
        setPpms(data.data);
      } else {
        setPpms([]);
      }
    } catch {
      setPpms([]);
    }
  };

  useEffect(() => {
    async function fetchAppUsers() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/app-users", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setAppUsers(data.data);
        } else {
          setAppUsers([]);
        }
      } catch {
        setAppUsers([]);
      }
    }
    fetchPPMs();
    fetchAppUsers();
  }, []);

  // Filter, sort, and paginate
  // Improved search: split search string into words, ignore extra spaces, match if all words are present in any field
  const filtered = ppms.filter(p => {
    const fields = [p.customerName, p.jobNumber, p.site].map(val => (val || '').toLowerCase());
    const searchWords = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (searchWords.length === 0) return true;
    return searchWords.every(word => fields.some(field => field.includes(word)));
  });
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice().slice((page-1)*pageSize, page*pageSize);

  const formatDateForDisplay = (d) => {
    if (!d) return "—";
    const x = new Date(d);
    return isNaN(x.getTime()) ? d : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };
  
  // Reset page to 1 if current page is beyond available pages
  if (filtered.length === 0 && page > 1) {
    setPage(1);
  }

  // Signature pad handlers for Add Modal
  const clearClientSignature = () => {
    if (clientSigCanvasRef.current) {
    clientSigCanvasRef.current.clear();
    }
    setNewPPM(prev => ({ ...prev, clientSignature: "" }));
  };
  const saveClientSignature = () => {
    if (clientSigCanvasRef.current && !clientSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = clientSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setNewPPM(prev => ({
        ...prev,
        clientSignature: sig
      }));
    }
  };
  const clearEngineerSignature = () => {
    if (engineerSigCanvasRef.current) {
    engineerSigCanvasRef.current.clear();
    }
    setNewPPM(prev => ({ ...prev, engineerSignature: "" }));
  };
  const saveEngineerSignature = () => {
    if (engineerSigCanvasRef.current && !engineerSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = engineerSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setNewPPM(prev => ({
        ...prev,
        engineerSignature: sig
      }));
    }
  };

  // Add PPM
  const handleAdd = async () => {
    // Basic validation
    if (!newPPM.customerName || !newPPM.jobNumber || !newPPM.site || !newPPM.date || !newPPM.engineerName || !newPPM.timeOn || !newPPM.timeOff || !newPPM.clientSignature || !newPPM.engineerSignature) {
      toast.error("All fields are required");
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      
      // Get user details for saving firstName and lastName
      const user = appUsers.find(u => u._id === newPPM.userId);
      const addedByFirstName = user ? user.firstName : '';
      const addedByLastName = user ? user.lastName : '';
      
      const ppmToSave = {
        ...newPPM,
        formUuid: ensureFormUuid(newPPM.formUuid),
        addedByFirstName,
        addedByLastName
      };
      
      const res = await fetch(baseUrl + "/api/ukpn-ppm", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(ppmToSave)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        if (noopCreateSuccess(data)) {
          toast.warn(data.message || "This record already exists. No new record was added.");
          return;
        }
        setPpms([...ppms, data.data]);
        setShowAddModal(false);
        setNewPPM({
          formUuid: '', userId: '', customerName: '', jobNumber: '', site: '', date: '', engineerName: '', timeOn: '', timeOff: '', comments: '', materials: '', clientSignature: '', engineerSignature: ''
        });
        toast.success("UKPN PPM added!");
      } else {
        toast.error(data.message || "Failed to add");
      }
    } catch {
      toast.error("Failed to add");
    }
  };

  // Edit PPM
  const handleEdit = (ppm) => {
    setEditPPM({ ...ppm, formUuid: ensureFormUuid(ppm?.formUuid) });
    setShowEditModal(true);
    setTimeout(() => {
      // Load client signature
      if (editClientSigCanvasRef.current) {
        editClientSigCanvasRef.current.clear();
        if (ppm.clientSignature) {
        let sigSrc = ppm.clientSignature;
        if (!sigSrc.startsWith('data:image')) {
          sigSrc = 'data:image/png;base64,' + sigSrc;
        }
        const img = new window.Image();
        img.onload = () => {
            if (editClientSigCanvasRef.current) {
              const canvas = editClientSigCanvasRef.current.getCanvas();
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              // Draw the image with proper scaling to maintain aspect ratio
              const canvasAspect = canvas.width / canvas.height;
              const imgAspect = img.width / img.height;
              
              let drawWidth, drawHeight, drawX, drawY;
              
              if (imgAspect > canvasAspect) {
                // Image is wider than canvas
                drawWidth = canvas.width;
                drawHeight = canvas.width / imgAspect;
                drawX = 0;
                drawY = (canvas.height - drawHeight) / 2;
              } else {
                // Image is taller than canvas
                drawHeight = canvas.height;
                drawWidth = canvas.height * imgAspect;
                drawX = (canvas.width - drawWidth) / 2;
                drawY = 0;
              }
              
              ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
            }
          };
          img.onerror = () => {
            console.error('Failed to load client signature image');
          };
          img.src = sigSrc;
        }
      }
      // Load engineer signature
      if (editEngineerSigCanvasRef.current) {
        editEngineerSigCanvasRef.current.clear();
        if (ppm.engineerSignature) {
        let sigSrc = ppm.engineerSignature;
        if (!sigSrc.startsWith('data:image')) {
          sigSrc = 'data:image/png;base64,' + sigSrc;
        }
        const img = new window.Image();
        img.onload = () => {
            if (editEngineerSigCanvasRef.current) {
              const canvas = editEngineerSigCanvasRef.current.getCanvas();
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              // Draw the image with proper scaling to maintain aspect ratio
              const canvasAspect = canvas.width / canvas.height;
              const imgAspect = img.width / img.height;
              
              let drawWidth, drawHeight, drawX, drawY;
              
              if (imgAspect > canvasAspect) {
                // Image is wider than canvas
                drawWidth = canvas.width;
                drawHeight = canvas.width / imgAspect;
                drawX = 0;
                drawY = (canvas.height - drawHeight) / 2;
              } else {
                // Image is taller than canvas
                drawHeight = canvas.height;
                drawWidth = canvas.height * imgAspect;
                drawX = (canvas.width - drawWidth) / 2;
                drawY = 0;
              }
              
              ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
            }
          };
          img.onerror = () => {
            console.error('Failed to load engineer signature image');
          };
          img.src = sigSrc;
        }
      }
    }, 200);
  };
  // Signature pad handlers for Edit Modal
  const clearEditClientSignature = () => {
    if (editClientSigCanvasRef.current) {
    editClientSigCanvasRef.current.clear();
    }
    setEditClientSignature("");
    setEditPPM(prev => ({ ...prev, clientSignature: "" }));
  };
  const saveEditClientSignature = () => {
    if (editClientSigCanvasRef.current && !editClientSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = editClientSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditClientSignature(sig);
      setEditPPM(prev => ({ ...prev, clientSignature: sig }));
    }
  };
  const clearEditEngineerSignature = () => {
    if (editEngineerSigCanvasRef.current) {
    editEngineerSigCanvasRef.current.clear();
    }
    setEditEngineerSignature("");
    setEditPPM(prev => ({ ...prev, engineerSignature: "" }));
  };
  const saveEditEngineerSignature = () => {
    if (editEngineerSigCanvasRef.current && !editEngineerSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = editEngineerSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditEngineerSignature(sig);
      setEditPPM(prev => ({ ...prev, engineerSignature: sig }));
    }
  };

  const handleEditSave = async () => {
    if (!editPPM.customerName || !editPPM.jobNumber || !editPPM.site || !editPPM.date || !editPPM.engineerName || !editPPM.timeOn || !editPPM.timeOff || !editPPM.clientSignature || !editPPM.engineerSignature) {
      toast.error("All fields are required");
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      
      // Get user details for saving firstName and lastName
      const user = appUsers.find(u => u._id === editPPM.userId);
      const addedByFirstName = user ? user.firstName : '';
      const addedByLastName = user ? user.lastName : '';
      
      const ppmToSave = {
        ...editPPM,
        formUuid: ensureFormUuid(editPPM.formUuid),
        addedByFirstName,
        addedByLastName
      };
      
      const res = await fetch(baseUrl + `/api/ukpn-ppm/${editPPM._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(ppmToSave)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setPpms(ppms.map(p => p._id === editPPM._id ? { ...editPPM } : p));
        setShowEditModal(false);
        toast.success("UKPN PPM updated!");
      } else {
        toast.error(data.message || "Failed to update");
      }
    } catch {
      toast.error("Failed to update");
    }
  };

  // Delete PPM
  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const res = await fetch(baseUrl + `/api/ukpn-ppm/${deleteId}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setPpms(ppms.filter(p => p._id !== deleteId));
        toast.success("Deleted successfully!");
      } else {
        toast.error(data.message || "Failed to delete");
      }
    } catch {
      toast.error("Failed to delete");
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const handleSharePointUpload = async () => {
    const siteNameForUpload = (sharePointUploadRecord?.site || '').trim();

    if (!siteNameForUpload) {
      toast.error('Site name is missing for this record.');
      return;
    }

    if (sharePointPhaseType === 'phase' && (!sharePointNetwork || sharePointNetwork.trim() === '')) {
      toast.error('Please select an area (EPN, LPN, or SPN)');
      return;
    }

    const payloadPhaseType = sharePointPhaseType === 'phase' ? 'phase' : 'non-phase';
    const payloadNetwork = sharePointPhaseType === 'phase' ? sharePointNetwork : '';
    const payloadPhaseNumber = sharePointPhaseType === 'phase' ? sharePointPhaseNumber : '';

    setShowSharePointUploadModal(false);

    await generatePDF(sharePointUploadRecord, {
      uploadOnly: true,
      phaseType: payloadPhaseType,
      phaseNumber: payloadPhaseNumber,
      network: payloadNetwork,
      siteName: siteNameForUpload,
      onSuccess: () => {
        setSharePointUploadRecord(null);
        setSharePointPhaseType('phase');
        setSharePointPhaseNumber('15');
        setSharePointNetwork('');
      },
      onError: () => {}
    });
  };

  const generatePDF = async (record, options = {}) => {
    // Prevent duplicate calls
    if (generatingPdfRef.current) {
      return;
    }
    generatingPdfRef.current = true;
    
    const shouldUploadToSharePoint = options.uploadOnly === true;
    const uploadConfig = shouldUploadToSharePoint ? {
      phaseType: options.phaseType || 'non-phase',
      phaseNumber: options.phaseNumber || '',
      network: options.network || '',
      siteName: options.siteName || '',
      uploadContext: options.uploadContext || '',
      onSuccess: options.onSuccess,
      onError: options.onError
    } : null;
    // Require a valid job number before proceeding
    if (!record?.jobNumber || String(record.jobNumber).trim() === "") {
      toast.error("Job Number is required before generating/uploading PDF.");
      generatingPdfRef.current = false;
      return;
    }
    
    try {
      const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    
    // Modern color scheme
    const primaryColor = [139, 22, 52]; // #8b1634
    const secondaryColor = [233, 207, 214]; // #e9cfd6
    const headerColor = [139, 22, 52]; // Dark magenta
    
    // Helper function to draw modern rounded rectangle
    const drawRoundedRect = (x, y, width, height, radius, fillColor, strokeColor, hasShadow = false) => {
      if (hasShadow) {
        doc.setFillColor(0, 0, 0, 0.1);
        doc.roundedRect(x + 1, y + 1, width, height, radius, radius, 'F');
      }
      doc.setFillColor(...fillColor);
      doc.setDrawColor(...strokeColor);
      doc.setLineWidth(0.5);
      doc.roundedRect(x, y, width, height, radius, radius, 'FD');
    };
    
    // ---- HEADER SECTION ----
    const headerHeight = 30;
    drawRoundedRect(0, 0, pageWidth, headerHeight, 0, primaryColor, primaryColor);
    
    // ---- ADD HIGH-RES LOGO ----
    const addLogoToPDF = () => {
      return new Promise((resolve) => {
        const logoImg = new Image();
        logoImg.crossOrigin = 'anonymous';
        logoImg.onload = function () {
          try {
            const logoWidth = 70;
            const aspectRatio = logoImg.height / logoImg.width;
            const logoHeight = logoWidth * aspectRatio;
            const logoX = 10;
            const logoY = (headerHeight - logoHeight) / 2;
            
            const canvas = document.createElement('canvas');
            const scale = 2.5;
            canvas.width = logoImg.width * scale;
            canvas.height = logoImg.height * scale;
            const ctx = canvas.getContext('2d');
            ctx.scale(scale, scale);
            ctx.drawImage(logoImg, 0, 0);
            
            const highResDataUrl = canvas.toDataURL('image/png', 1.0);
            doc.addImage(highResDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight, '', 'NONE');
          } catch (error) {
            doc.setFillColor(255, 255, 255);
            doc.rect(10, 6, 60, 15, 'F');
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text("TAYLOR TECHNOLOGY", 15, 12);
            doc.text("SYSTEMS LIMITED", 15, 17);
          }
          resolve();
        };
        logoImg.onerror = function () {
          doc.setFillColor(255, 255, 255);
          doc.rect(10, 6, 60, 15, 'F');
          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 0);
          doc.text("TAYLOR TECHNOLOGY", 15, 12);
          doc.text("SYSTEMS LIMITED", 15, 17);
          resolve();
        };
        logoImg.src = onsiteproLogo;
      });
    };
    
    await addLogoToPDF();
    
    // ---- HEADER TEXT ----
    const titleX = 90;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("UKPN PPM Report", titleX, 13);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("TAYLOR TECHNOLOGY SYSTEMS LIMITED", titleX, 19);
    
    let yPosition = headerHeight + 10;
    
    // ---- Section 1: Basic Information ----
    doc.setFillColor(139, 22, 52);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    
    doc.rect(10, yPosition, pageWidth - 20, 8, "F");
    doc.text("1", 14, yPosition + 5.5);
    doc.text("Basic Information", 22, yPosition + 5.5);
    yPosition += 8;
    
    autoTable(doc, {
      startY: yPosition,
      columnStyles: {
        0: { cellWidth: 50 },
        1: { cellWidth: 65 },
        2: { cellWidth: 30 },
        3: { cellWidth: 45 },
      },
      head: [
        [
          { content: "Customer Name:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.customerName || "", styles: { halign: "center" } },
          { content: "Job Number:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.jobNumber || "", styles: { halign: "center" } },
        ],
        [
          { content: "Site:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.site || "", styles: { halign: "center" } },
          { content: "Date:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.date || "", styles: { halign: "center" } },
        ],
        [
          { content: "Engineer Name:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.engineerName || "", colSpan: 3, styles: { halign: "center" } },
        ],
        [
          { content: "Time In:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.timeOn || "", styles: { halign: "center" } },
          { content: "Time Out:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
          { content: record.timeOff || "", styles: { halign: "center" } },
        ],
      ],
      body: [
        [
          { content: "Materials Used:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.materials || "", colSpan: 3, styles: { halign: "center" } },
        ],
        [
          { content: "Comments:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
          { content: record.comments || "", colSpan: 3, styles: { halign: "left" } },
        ],
      ],
      styles: {
        font: "helvetica",
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        valign: "middle",
      },
      theme: "grid",
      tableWidth: pageWidth - 20,
      margin: { left: 10 },
      headStyles: {
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      bodyStyles: {
        lineWidth: 0.2,
        textColor: [0, 0, 0],
      },
    });
    
    yPosition = doc.lastAutoTable.finalY + 2;
    
    // ---- Section 2: Signatories ----
    if (yPosition + 60 > pageHeight - 30) {
      doc.addPage();
      yPosition = 20;
    }
    
    doc.setFillColor(139, 22, 52);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.rect(10, yPosition, pageWidth - 20, 10, "F");
    doc.text("Section 2 : Signatories", 15, yPosition + 7);
    yPosition += 18;
    
    // Two signature boxes side by side
    const boxWidth = (pageWidth - 30) / 2;
    const boxHeight = 40;
    
    // Helper function to add signature with high quality
    const addSignatureToPDF = async (signatureData, x, y, maxWidth, maxHeight) => {
      if (!signatureData) return;
      
      try {
        // Ensure proper data URL format
        let sigSrc = signatureData;
        if (!sigSrc.startsWith('data:image')) {
          sigSrc = 'data:image/png;base64,' + sigSrc;
        }
        
        return new Promise((resolve) => {
          const sigImg = new Image();
          sigImg.crossOrigin = 'anonymous';
          
          sigImg.onload = () => {
            try {
              // Calculate dimensions maintaining aspect ratio with smaller size
              const aspectRatio = sigImg.width / sigImg.height;
              
              // Use smaller fixed size for compact display
              const targetWidth = 50; // Reduced from 60
              const targetHeight = 22; // Reduced from 28
              
              let imgWidth = targetWidth;
              let imgHeight = targetWidth / aspectRatio;
              
              // If height exceeds max, adjust width
              if (imgHeight > targetHeight) {
                imgHeight = targetHeight;
                imgWidth = targetHeight * aspectRatio;
              }
              
              // Ensure it doesn't exceed maxWidth
              if (imgWidth > maxWidth) {
                imgWidth = maxWidth;
                imgHeight = maxWidth / aspectRatio;
              }
              if (imgHeight > maxHeight) {
                imgHeight = maxHeight;
                imgWidth = maxHeight * aspectRatio;
              }
              
              // Create high-resolution canvas for better quality
              const scale = 4; // Higher scale for better quality
              const canvas = document.createElement('canvas');
              // Convert PDF dimensions (mm) to pixels for canvas
              const mmToPixels = 72 / 25.4;
              canvas.width = Math.round(imgWidth * mmToPixels * scale);
              canvas.height = Math.round(imgHeight * mmToPixels * scale);
              
              const ctx = canvas.getContext('2d');
              
              // Enable high-quality image smoothing
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';
              
              // Clear canvas with white background
              ctx.fillStyle = '#FFFFFF';
              ctx.fillRect(0, 0, canvas.width, canvas.height);
              
              // Draw image scaled up to canvas size
              ctx.drawImage(sigImg, 0, 0, sigImg.width, sigImg.height, 0, 0, canvas.width, canvas.height);
              
              // Convert to high-res data URL with maximum quality
              const highResDataUrl = canvas.toDataURL('image/png', 1.0);
              
              // Add to PDF with original dimensions
              doc.addImage(highResDataUrl, 'PNG', x, y, imgWidth, imgHeight, '', 'NONE');
            } catch (err) {
              console.error('Error adding signature to PDF:', err);
            }
            resolve();
          };
          
          sigImg.onerror = () => {
            console.error('Error loading signature image');
            resolve();
          };
          
          sigImg.src = sigSrc;
        });
      } catch (err) {
        console.error('Signature processing error:', err);
      }
    };
    
    // Client Signature box
    doc.setDrawColor(200, 200, 200);
    doc.setFillColor(248, 248, 248);
    doc.roundedRect(10, yPosition, boxWidth, boxHeight, 3, 3, "FD");
    
    doc.setTextColor(139, 22, 52);
    doc.setFontSize(10);
    doc.text("Client Signature", 15, yPosition + 8);
    
    // Add client signature using helper function with smaller size
    // Calculate center position within box
    const clientSigX = 15;
    const clientSigY = yPosition + 12;
    await addSignatureToPDF(record.clientSignature, clientSigX, clientSigY, 50, 22);
    
    // Engineer Signature box
    const engineerBoxX = 10 + boxWidth + 10;
    doc.setDrawColor(200, 200, 200);
    doc.setFillColor(248, 248, 248);
    doc.roundedRect(engineerBoxX, yPosition, boxWidth, boxHeight, 3, 3, "FD");
    
    doc.setTextColor(139, 22, 52);
    doc.setFontSize(10);
    doc.text("Engineer Signature", engineerBoxX + 5, yPosition + 8);
    
    // Add engineer signature using helper function with smaller size
    const engineerSigX = engineerBoxX + 5;
    const engineerSigY = yPosition + 12;
    await addSignatureToPDF(record.engineerSignature, engineerSigX, engineerSigY, 50, 22);
    
    yPosition += boxHeight + 10;
    
    // ---- Footer Section ----
    const footerY = pageHeight - 25;
    drawRoundedRect(0, footerY, pageWidth, 25, 0, [248, 249, 250], [200, 200, 200]);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(
      `Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`,
      20,
      footerY + 8
    );
    doc.text("Page 1 of 1", pageWidth - 30, footerY + 15);
    
    // Decorative border removed
    
    // Build filename and either save or upload
    const safeName = String(record.customerName || 'UKPNPPM').replace(/[\\/:"*?<>|]+/g, '-');
    const safeDate = String(record.date || 'Report').replace(/[\\/:"*?<>|]+/g, '-');
    
    let fileName;
    if (shouldUploadToSharePoint && uploadConfig) {
      fileName = buildSharePointFileName([
        record.customerName,
        uploadConfig.siteName,
        toDdMmYyyy(record.date),
      ]);
    } else {
      // For regular download, use full format with prefix and date
      fileName = `UKPNPPM_${safeName}_${safeDate}.pdf`;
    }
    
    if (shouldUploadToSharePoint && uploadConfig) {
      try {
        const key = `${record._id || ''}|${record.jobNumber || ''}|${record.date || ''}`;
        setUploadingKey(key);
        const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
        const dataUri = doc.output('datauristring');
        const uploadParams = {
          fileName,
          fileBase64: dataUri,
          phaseType: uploadConfig.phaseType,
          phaseNumber: uploadConfig.phaseNumber,
          network: uploadConfig.network,
          siteName: uploadConfig.siteName,
          uploadContext: uploadConfig.uploadContext, uploadSubFolder: "UKPN PPM Worksheet"
        };
        const res = await fetch(`${apiUrl}/api/sharepoint/upload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify(uploadParams)
        });
        if (res.status !== 204 && !res.ok) {
          let msg = 'SharePoint upload failed';
          try {
            const out = await res.json();
            msg = out?.message || msg;
          } catch (_) {}
          throw new Error(msg);
        }
        toast.success("PDF uploaded to SharePoint successfully!");
        if (uploadConfig.onSuccess) {
          uploadConfig.onSuccess();
        }
      } catch (err) {
        toast.error(err?.message || "SharePoint upload failed");
        if (uploadConfig.onError) {
          uploadConfig.onError(err);
        }
      } finally {
        setUploadingKey(null);
      }
    } else {
      doc.save(fileName);
      toast.success("Professional UKPN PPM PDF generated successfully!");
    }
    } catch (err) {
      console.error('Error generating PDF:', err);
      toast.error('Failed to generate PDF');
    } finally {
      generatingPdfRef.current = false;
    }
  };

  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '20px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      padding: '24px',
      marginBottom: '24px'
    }}>
      {/* Header Section */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#1a202c',
          margin: 0
        }}>UKPN PPM</h2>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          {isAdminUser && (
            <button
              type="button"
              onClick={() => setShowImportModal(true)}
              style={{
                background: "#8b1634",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 14px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Import File
            </button>
          )}
        <div style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center'
        }}>
          <i className="fa fa-search" style={{
            position: 'absolute',
            left: '12px',
            color: '#8b1634',
            fontSize: '14px'
          }}></i>
          <input 
            type="text" 
            placeholder="Type to Search" 
            value={search} 
            onChange={e=>{ setSearch(e.target.value); setPage(1); }}
            style={{
              padding: '10px 12px 10px 36px',
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              fontSize: '14px',
              outline: 'none',
              width: '250px',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#8b1634'}
            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
          />
        </div>
        </div>
      </div>

      {/* Table Container */}
      <div style={{
        overflowX: 'auto',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 0.8fr 1fr 0.8fr 1fr 1fr 1fr 1.2fr',
          background: '#f7fafc',
          padding: '12px 16px',
          borderBottom: '1px solid #e2e8f0',
          gap: '12px',
          alignItems: 'center'
        }}>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Customer Name</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Job Number</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Site</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Engineer Name</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Added By</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Updated Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Actions</div>
        </div>

        {/* Table Body */}
        <div>
          {paged.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#718096',
              fontSize: '16px'
            }}>No records found.</div>
          ) : paged.map((p, idx) => {
              // First check if firstName and lastName are saved in the record
              // If not, try to find user from appUsers array
              let userName = '-';
              if (p.addedByFirstName && p.addedByLastName) {
                userName = `${p.addedByFirstName} ${p.addedByLastName}`;
              } else {
                const user = appUsers.find(u => u._id === p.userId);
                userName = user ? `${user.firstName} ${user.lastName}` : (p.userId || '-');
              }
              return (
                <div 
                  key={p._id || idx}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 0.8fr 1fr 0.8fr 1fr 1fr 1fr 1.2fr',
                    padding: '16px',
                    borderBottom: '1px solid #f1f5f9',
                    gap: '12px',
                    alignItems: 'center',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{p.customerName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{p.jobNumber || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{p.site || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{p.date || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{p.engineerName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{userName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatDateForDisplay(p.updatedAt || p.createdAt)}</div>
                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                  {canEditDelete && (
                    <button 
                      onClick={()=>handleEdit(p)}
                      title="Edit"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className="fa fa-edit" style={{color:'#22c55e', fontSize: '16px'}}></i>
                    </button>
                  )}
                <button 
                  onClick={()=>generatePDF(p)}
                  title="Generate PDF"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '6px',
                    borderRadius: '6px',
                    transition: 'background-color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <i className="fa fa-file-pdf-o" style={{color:'#dc2626', fontSize: '16px'}}></i>
                </button>
                {(() => { 
                  const k = `${p._id || ''}|${p.jobNumber || ''}|${p.date || ''}`; 
                  const busy = uploadingKey === k; 
                  return (
                    <button 
                      onClick={()=>{
                        if (!busy) {
                          generatePDF(p, {
                            uploadOnly: true,
                            siteName: (p.site || 'UKPN Reactive Maintenance').trim(),
                            uploadContext: 'reactive-ukpn-tablets'
                          });
                        }
                      }}
                      disabled={busy}
                      title={busy ? "Uploading..." : "Upload to SharePoint"}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: busy ? 'not-allowed' : 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: busy ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !busy && (e.currentTarget.style.backgroundColor = '#f0fdf4')}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className={busy ? "fa fa-spinner fa-spin" : "fa fa-upload"} style={{color:'#22c55e', fontSize: '16px'}}></i>
                    </button>
                  ); 
                })()}
                  {canEditDelete && (
                    <button 
                      onClick={()=>handleDelete(p._id)}
                      title="Delete"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <i className="fa fa-trash" style={{color:'#e53e3e', fontSize: '16px'}}></i>
                      </button>
                  )}
                </div>
              </div>
              );
            })}
        </div>
      </div>

      {/* Pagination */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '18px',
        gap: '12px'
      }}>
        <button 
          className="horizon-table-btn" 
          disabled={page===1 || filtered.length === 0} 
          onClick={()=>setPage(page-1)}
          style={{
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            background: (page===1 || filtered.length === 0) ? '#f7fafc' : '#ffffff',
            color: (page===1 || filtered.length === 0) ? '#a0aec0' : '#8b1634',
            cursor: (page===1 || filtered.length === 0) ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >Prev</button>
        <span style={{
          fontWeight: '700',
          color: '#8b1634',
          fontSize: '16px'
        }}>{page} / {totalPages}</span>
        <button 
          className="horizon-table-btn" 
          disabled={page===totalPages || filtered.length === 0} 
          onClick={()=>setPage(page+1)}
          style={{
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            background: (page===totalPages || filtered.length === 0) ? '#f7fafc' : '#ffffff',
            color: (page===totalPages || filtered.length === 0) ? '#a0aec0' : '#8b1634',
            cursor: (page===totalPages || filtered.length === 0) ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >Next</button>
      </div>

      {/* Add Modal */}
        {showAddModal && (
          <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content" style={{maxWidth:'800px', margin:'0 auto'}}>
                <div className="modal-header">
                  <h5 className="modal-title">Add UKPN PPM</h5>
                  <button type="button" className="btn-close" onClick={()=>setShowAddModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="row mb-2">
                    <div className="col-6">
                      <label>Customer Name</label>
                      <input className="form-control" placeholder="Customer Name" value={newPPM.customerName} onChange={e=>setNewPPM({...newPPM, customerName: e.target.value})} />
                    </div>
                    <div className="col-6">
                      <label>Job Number</label>
                      <input className="form-control" placeholder="Job Number" value={newPPM.jobNumber} onChange={e=>setNewPPM({...newPPM, jobNumber: e.target.value})} />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-6">
                      <label>Site</label>
                      <input className="form-control" placeholder="Site" value={newPPM.site} onChange={e=>setNewPPM({...newPPM, site: e.target.value})} />
                    </div>
                    <div className="col-6">
                      <label>Date</label>
                       <input className="form-control" type="date" placeholder="Date" value={newPPM.date ? newPPM.date.split('/').reverse().join('-') : ''} onChange={e=>setNewPPM({...newPPM, date: e.target.value.split('-').reverse().join('/')})} />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-6">
                      <label>Engineer Name</label>
                      <input className="form-control" placeholder="Engineer Name" value={newPPM.engineerName} onChange={e=>setNewPPM({...newPPM, engineerName: e.target.value})} />
                    </div>
                    <div className="col-3">
                      <label>Time In</label>
                      <input className="form-control" type="time" placeholder="Time In" value={newPPM.timeOn} onChange={e=>setNewPPM({...newPPM, timeOn: e.target.value})} />
                    </div>
                    <div className="col-3">
                      <label>Time Out</label>
                      <input className="form-control" type="time" placeholder="Time Out" value={newPPM.timeOff} onChange={e=>setNewPPM({...newPPM, timeOff: e.target.value})} />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label>Materials Used</label>
                      <input className="form-control" placeholder="Materials Used" value={newPPM.materials} onChange={e=>setNewPPM({...newPPM, materials: e.target.value})} />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-12">
                      <label>Comments</label>
                      <textarea className="form-control" rows={5} placeholder="Comments" value={newPPM.comments} onChange={e=>setNewPPM({...newPPM, comments: e.target.value})} />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6 mb-2">
                      <label className="form-label fw-semibold text-secondary">Client Signature</label>
                      <div style={{
                        width: '100%',
                        border: '2px solid #8b1634',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        padding: '0.5rem',
                        textAlign: 'left',
                        position: 'relative',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          width: '100%',
                          height: '100px',
                          position: 'relative',
                          display: 'block'
                        }}>
                        <SignatureCanvas
                          ref={clientSigCanvasRef}
                          penColor="#8b1634"
                            backgroundColor="white"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={1}
                          maxWidth={2.5}
                          dotSize={1.5}
                          throttle={16}
                            canvasProps={{
                              width: 500,
                              height: 80,
                              style: {
                                width: '100%',
                                height: '80px',
                                border: 'none',
                                borderRadius: '12px',
                                background: 'white',
                                display: 'block',
                                touchAction: 'none',
                                cursor: 'crosshair',
                                position: 'relative'
                              }
                            }}
                          onEnd={saveClientSignature}
                        />
                        </div>
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '8px'
                        }}>
                          <span style={{
                            fontSize: '12px',
                            color: '#8b1634',
                            fontStyle: 'italic'
                          }}>
                            Draw your signature above
                          </span>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                            style={{
                              background: 'transparent',
                              color: '#8b1634',
                              borderColor: '#8b1634'
                            }}
                            onClick={clearClientSignature}>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label className="form-label fw-semibold text-secondary">Engineer Signature</label>
                      <div style={{
                        width: '100%',
                        border: '2px solid #8b1634',
                        borderRadius: '18px',
                        background: '#e9cfd6',
                        padding: '0.5rem',
                        textAlign: 'left',
                        position: 'relative',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <div style={{
                          width: '100%',
                          height: '100px',
                          position: 'relative',
                          display: 'block'
                        }}>
                        <SignatureCanvas
                          ref={engineerSigCanvasRef}
                          penColor="#8b1634"
                            backgroundColor="white"
                          clearOnResize={false}
                          velocityFilterWeight={0.7}
                          minWidth={1}
                          maxWidth={2.5}
                          dotSize={1.5}
                          throttle={16}
                            canvasProps={{
                              width: 500,
                              height: 80,
                              style: {
                                width: '100%',
                                height: '80px',
                                border: 'none',
                                borderRadius: '12px',
                                background: 'white',
                                display: 'block',
                                touchAction: 'none',
                                cursor: 'crosshair',
                                position: 'relative'
                              }
                            }}
                          onEnd={saveEngineerSignature}
                        />
                        </div>
                        <div style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '8px'
                        }}>
                          <span style={{
                            fontSize: '12px',
                            color: '#8b1634',
                            fontStyle: 'italic'
                          }}>
                            Draw your signature above
                          </span>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                            style={{
                              background: 'transparent',
                              color: '#8b1634',
                              borderColor: '#8b1634'
                            }}
                            onClick={clearEngineerSignature}>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={()=>setShowAddModal(false)}>Cancel</button>
                  <button className="btn btn-success" onClick={handleAdd}>Add</button>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Edit Modal */}
        {showEditModal && editPPM && (
          <div className="modal fade show" style={adminEditModalOverlayStyle} tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content" style={adminEditModalContentStyle}>
                <div className="modal-header" style={adminEditModalHeaderStyle}>
                  <h5 className="modal-title" style={adminEditModalTitleStyle}>Edit UKPN PPM</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowEditModal(false)} />
                </div>
                <div className="modal-body" style={adminEditModalBodyStyle}>
                  <div className="row g-3 mb-1">
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Customer Name</label>
                      <input className="form-control" style={adminEditInputStyle} placeholder="Customer Name" value={editPPM.customerName} onChange={e=>setEditPPM({...editPPM, customerName: e.target.value})} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Job Number</label>
                      <input
                        className="form-control"
                        style={adminEditInputStyle}
                        placeholder="Job Number"
                        value={editPPM.jobNumber}
                        onChange={e=>{
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          setEditPPM({...editPPM, jobNumber: value});
                        }}
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Site</label>
                      <input className="form-control" style={adminEditInputStyle} placeholder="Site" value={editPPM.site} onChange={e=>setEditPPM({...editPPM, site: e.target.value})} />
                    </div>
                  </div>
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Date</label>
                      <div className="site-register-datepicker-wrap">
                        <DatePicker
                          {...siteRegisterDatePickerProps}
                          selected={parseSiteRegisterDate(editPPM.date)}
                          onChange={(d) => setEditPPM({ ...editPPM, date: formatSiteRegisterDate(d) })}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Engineer Name</label>
                      <input className="form-control" style={adminEditInputStyle} placeholder="Engineer Name" value={editPPM.engineerName} onChange={e=>setEditPPM({...editPPM, engineerName: e.target.value})} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Materials Used</label>
                      <input className="form-control" style={adminEditInputStyle} placeholder="Materials Used" value={editPPM.materials} onChange={e=>setEditPPM({...editPPM, materials: e.target.value})} />
                    </div>
                  </div>
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Time In</label>
                      <input className="form-control" style={adminEditInputStyle} type="time" placeholder="Time In" value={editPPM.timeOn} onChange={e=>setEditPPM({...editPPM, timeOn: e.target.value})} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label style={adminEditLabelStyle}>Time Out</label>
                      <input className="form-control" style={adminEditInputStyle} type="time" placeholder="Time Out" value={editPPM.timeOff} onChange={e=>setEditPPM({...editPPM, timeOff: e.target.value})} />
                    </div>
                  </div>
                  <div className="row g-3 mt-1">
                    <div className="col-12">
                      <label style={adminEditLabelStyle}>Comments</label>
                      <textarea className="form-control" style={adminEditInputStyle} rows={5} placeholder="Comments" value={editPPM.comments} onChange={e=>setEditPPM({...editPPM, comments: e.target.value})} />
                    </div>
                  </div>
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-md-6">
                      <label style={adminEditLabelStyle}>Client Signature</label>
                      <div style={adminEditSigBoxStyle()}>
                        {editPPM.clientSignature ? (
                          <img
                            src={editPPM.clientSignature.startsWith('data:image')
                              ? editPPM.clientSignature
                              : `data:image/png;base64,${editPPM.clientSignature}`}
                            alt="Client Signature"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '8px',
                              padding: '4px',
                              backgroundColor: 'white',
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                            Signature (Disabled in Edit)
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <label style={adminEditLabelStyle}>Engineer Signature</label>
                      <div style={adminEditSigBoxStyle()}>
                        {editPPM.engineerSignature ? (
                          <img
                            src={editPPM.engineerSignature.startsWith('data:image')
                              ? editPPM.engineerSignature
                              : `data:image/png;base64,${editPPM.engineerSignature}`}
                            alt="Engineer Signature"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '8px',
                              padding: '4px',
                              backgroundColor: 'white',
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                            Signature (Disabled in Edit)
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={adminEditModalFooterStyle}>
                  <button type="button" className="btn" style={adminEditCancelBtnStyle} onClick={()=>setShowEditModal(false)}>Cancel</button>
                  <button type="button" className="btn" style={adminEditSaveBtnStyle} onClick={handleEditSave}>Save</button>
                </div>
              </div>
            </div>
          </div>
        )}

      <AdminTaylorImportModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Upload UKPN PPM File"
        importPath="ukpn-ppm/import-form"
        isAdminUser={isAdminUser}
        onImported={({ insertedRow }) => {
          if (insertedRow && insertedRow._id) {
            setPpms((prev) => [insertedRow, ...prev]);
            setPage(1);
          }
        }}
      />

      {/* Delete Modal */}
        {showDeleteModal && (
          <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete UKPN PPM</h5>
                  <button type="button" className="btn-close" onClick={()=>setShowDeleteModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this record?</p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={()=>setShowDeleteModal(false)}>Cancel</button>
                  <button className="btn btn-danger" onClick={confirmDelete}>Delete</button>
                </div>
              </div>
            </div>
          </div>
        )}

      {showSharePointUploadModal && sharePointUploadRecord && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'600px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Upload to SharePoint</h5>
                <button type="button" className="btn-close" onClick={()=>{
                  setShowSharePointUploadModal(false);
                  setSharePointUploadRecord(null);
                  setSharePointPhaseType('phase');
                  setSharePointPhaseNumber('15');
                  setSharePointNetwork('');
                }}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-12">
                    <label className="form-label fw-semibold">Type <span style={{color:'red'}}>*</span></label>
                    <select 
                      className="form-select" 
                      value={sharePointPhaseType}
                      onChange={(e) => {
                        setSharePointPhaseType(e.target.value);
                        if (e.target.value === 'non-phase') {
                          setSharePointNetwork('');
                        }
                      }}
                    >
                      <option value="phase">Phase</option>
                      <option value="non-phase">Non Phase</option>
                    </select>
                  </div>
                  
                  {sharePointPhaseType === 'phase' && (
                    <>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Phase Number <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointPhaseNumber}
                          onChange={(e) => {
                            setSharePointPhaseNumber(e.target.value);
                          }}
                        >
                          <option value="15">Phase 15 (2025)</option>
                          <option value="16">Phase 16 (2026)</option>
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Area <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointNetwork}
                          onChange={(e) => {
                            setSharePointNetwork(e.target.value);
                          }}
                        >
                          <option value="">Select Area</option>
                          <option value="EPN">EPN</option>
                          <option value="LPN">LPN</option>
                          <option value="SPN">SPN</option>
                        </select>
                      </div>
                    </>
                  )}
                  
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={()=>{
                    setShowSharePointUploadModal(false);
                    setSharePointUploadRecord(null);
                    setSharePointPhaseType('phase');
                    setSharePointPhaseNumber('15');
                    setSharePointNetwork('');
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn" 
                  style={{background:'#8b1634', color:'#fff', fontWeight:600}}
                  onClick={handleSharePointUpload}
                >
                  Upload to SharePoint
                </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default UkpnPPMPage;
